(function () {
    'use strict';

    angular
        .module('ResourceGenerator')
        .factory('GenericDsStore', GenericDsStore);

    function GenericDsStore() {
        var store = {};

    }
})();